import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { UIComponentsModule } from "../../ui-components/ui-components.module";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { getBillingStatusDescription, BILLING_STATUS, BillingRunSummary, DEFAULT_CURRENCY } from "../../common/organisation";
import { MaterialModule } from "../../material/material.module";
import { OrganisationService } from "../../organisation/organisation.service";

@Component({
    selector: 'app-billing-run-table',
    templateUrl: './billing-run-table.html',
    styleUrls: ['./billing-run-table.css'],
    standalone: true,
    imports: [MaterialModule, UIComponentsModule]
})
export class BillingRunTableComponent implements OnInit, OnChanges {
    @Input() billingRuns:BillingRunSummary[]
    @Input() selectedRunId:number
    
    billingData:MatTableDataSource<BillingRunSummary> = new MatTableDataSource<BillingRunSummary>()
    @ViewChild(MatSort) sort: MatSort

    initialColumns = ['runId', 'organisations', 'nodes', 'projects', 'users'];
    intialHeadings = ['Run ID', 'Organisations', 'Nodes', 'Projects', 'Users'];

    columns = []
    headings = []

    currencyCode:string

    @Output() selectRunEvent = new EventEmitter<number>();
    
    constructor(organisationService:OrganisationService) {
        this.currencyCode = organisationService.organisation?.currencyCode||DEFAULT_CURRENCY
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['billingRuns']) this.ngOnInit()
    }

    ngOnInit(): void {
        if (this.billingRuns && this.billingRuns.length > 0)
            this.populateData()
    }

    populateData() {
        const states = Object.keys(BILLING_STATUS).filter((v) => !isNaN(Number(v)))

        this.columns = this.initialColumns.concat(states)
        this.headings = this.intialHeadings.concat(states.map(s => {
            const status = parseInt(s) as BILLING_STATUS
            return getBillingStatusDescription(status)
        }))
        this.billingData.data = this.billingRuns.sort((a,b) => a.runId > b.runId?1:-1)
        this.billingData.sort = this.sort;
    }

    selectRow(row:BillingRunSummary) {
        this.selectedRunId = row.runId
        this.selectRunEvent.emit(row.runId)
    }
}
